import(/* webpackMode: "eager" */ "/codebuild/output/src3363517071/src/src/app/global-error.tsx");
